import {
  ADDEDIT_INTRODUCTION,
  AE_PROJECT_DODS,
  AE_PROJECT_EPICS,
  AE_PROJECT_GOAL,
  AE_PROJECT_IMP_TIMES,
  AE_PROJECT_LIMITATION,
  AE_PROJECT_PERSONAS,
  AE_PROJECT_RISK,
  AE_PROJECT_RULES,
  GET_MILESTONE_TASKS,
  GET_PROJECT_BENEFICARES,
  GET_PROJECT_CHARTER,
  GET_TASKMAP_CHARTER,
  GET_TASK_CHARTER,
} from "./CharterType";

export const CharterReducer = (
  state = {
    Limitations: [],
    Risks: [],
    Rules: [],
    DODs: [],
    Epics: [],
    Personas: [],
    ImportantTimes: [],
    Goals: [],
    MileStoneTasks: [],
    Introduction: {},
    Beneficiaries: {},
    Tasks: [],
  },
  action
) => {
  switch (action.type) {
    case GET_PROJECT_CHARTER: {
      const bc = action.Payload?.BoardCharter ?? {};
      return {
        ...state,
        Limitations: bc.Limitations ?? [],
        Risks: bc.Risks ?? [],
        Rules: bc.Rules ?? [],
        DODs: bc.DODs ?? [],
        Epics: bc.Epics ?? [],
        Personas: bc.Personas ?? [],
        ImportantTimes: bc.ImportantTimes ?? [],
        Goals: bc.Goals ?? [],
        Introduction: bc.Introduction ?? {},
        Beneficiaries: bc.Beneficiaries ?? {},
        Tasks: action.Payload?.FinalTasksData ?? [],
      };
    }
    case ADDEDIT_INTRODUCTION: {
      return {
        ...state,
        Introduction: action.Payload,
      };
    }
    case AE_PROJECT_GOAL: {
      return {
        ...state,
        Goals: action.Payload,
      };
    }
    case AE_PROJECT_LIMITATION: {
      return {
        ...state,
        Limitations: action.Payload,
      };
    }
    case AE_PROJECT_RISK: {
      return {
        ...state,
        Risks: action.Payload,
      };
    }
    case AE_PROJECT_RULES: {
      return {
        ...state,
        Rules: action.Payload,
      };
    }
    case AE_PROJECT_DODS: {
      return {
        ...state,
        DODs: action.Payload,
      };
    }
    case AE_PROJECT_EPICS: {
      return {
        ...state,
        Epics: action.Payload,
      };
    }
    case AE_PROJECT_PERSONAS: {
      return {
        ...state,
        Personas: action.Payload,
      };
    }
    case AE_PROJECT_IMP_TIMES: {
      return {
        ...state,
        ImportantTimes: action.Payload,
      };
    }
    case GET_MILESTONE_TASKS: {
      return {
        ...state,
        MileStoneTasks: action.Payload,
      };
    }
    case GET_PROJECT_BENEFICARES: {
      return {
        ...state,
        Beneficiaries: action.Payload,
      };
    }
    case GET_TASK_CHARTER: {
      const Charter = action.Payload.Charter ?? {};
      const TaskID = action.Payload.TaskID;
      const Tasks = state.Tasks ?? [];
      const Index = Tasks.findIndex(
        (item) =>
          String(item.TaskID) === String(TaskID) && !item.TaskMapID
      );

      if (Index === -1) {
        return {
          ...state,
          Tasks: [
            ...Tasks,
            {
              TaskID,
              Goals: Charter.Goals ?? [],
              Limitations: Charter.Limitations ?? [],
              Risks: Charter.Risks ?? [],
            },
          ],
        };
      }

      const NextTasks = [...Tasks];
      NextTasks[Index] = {
        ...NextTasks[Index],
        Goals: Charter.Goals ?? [],
        Limitations: Charter.Limitations ?? [],
        Risks: Charter.Risks ?? [],
      };
      return { ...state, Tasks: NextTasks };
    }
    case GET_TASKMAP_CHARTER: {
      const Charter = action.Payload.Charter ?? {};
      const TaskMapID = action.Payload.TaskMapID;
      const TaskID = action.Payload.TaskID;
      const Tasks = state.Tasks ?? [];
      const Index = Tasks.findIndex(
        (item) =>
          item.TaskMapID && String(item.TaskMapID) === String(TaskMapID)
      );

      if (Index === -1) {
        return {
          ...state,
          Tasks: [
            ...Tasks,
            {
              TaskID,
              TaskMapID,
              Goals: Charter.Goals ?? [],
              Limitations: Charter.Limitations ?? [],
              Risks: Charter.Risks ?? [],
            },
          ],
        };
      }

      const NextTasks = [...Tasks];
      NextTasks[Index] = {
        ...NextTasks[Index],
        Goals: Charter.Goals ?? [],
        Limitations: Charter.Limitations ?? [],
        Risks: Charter.Risks ?? [],
      };
      return { ...state, Tasks: NextTasks };
    }
    default: {
      return state;
    }
  }
};
